module.exports = __webpack_public_path__ + "media/images/crypto-currencies/iota-47565d8894ca58c7426b75b8a8609be4.svg";